import React, { useEffect } from "react";
import { Bell, User } from "lucide-react";
import { useNavigate } from "react-router";
import useAuthStore from "../../store/useAuthStore";
import useNotificationStore from "../../store/useNotificationStore";

const Navbar = ({ isOpen, setIsOpen }) => {
    const navigate = useNavigate();
    const logoutCustomer = useAuthStore((state) => state.logoutCustomer);
    const logoutAgent = useAuthStore((state) => state.logoutAgent);
    const user = useAuthStore((state) => state.user);
    const userType = useAuthStore((state) => state.userType);

    // Use the same notification store as builder, but for customer
    const { unreadCount, fetchUnreadCount } = useNotificationStore();

    useEffect(() => {
        fetchUnreadCount();
    }, [fetchUnreadCount]);

    const handlenav = (path) => {
        navigate(path);
    };

    const handleLogout = () => {
        if (userType === "customer") {
            logoutCustomer();
            navigate("/");
        } else if (userType === "agent") {
            logoutAgent();
            navigate("/");
        }
    };

    useEffect(() => {
        const handlePopState = () => {
            navigate("/");
        };

        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [navigate]);

    return (
        <div
            className="flex bg-white justify-between items-center px-1.5 xs:px-2 sm:px-4 py-2 font-poppins overflow-hidden"
            style={{ borderRadius: "8px", minHeight: "44px" }}
        >
            {/* Responsive greeting/name section */}
            <div className="flex items-center gap-1 sm:gap-4 flex-1 min-w-0">
                <div className="relative min-w-0">
                    <div className="text-sm sm:text-base font-semibold text-gray-800 truncate max-w-[80px] xxs:max-w-[100px] xs:max-w-[140px] sm:max-w-[200px]">
                        <span className="whitespace-nowrap">Hello {user?.name || "Agent"}</span>
                    </div>
                </div>
            </div>

            {/* Responsive icon and logout section */}
            <div className="flex items-center space-x-1 xs:space-x-1.5 sm:space-x-2 flex-shrink-0 ml-1">
                <button
                    onClick={() => handlenav("/agent/profile")}
                    className="w-8 h-8 sm:w-7 sm:h-7 bg-blue-500 rounded-full flex justify-center items-center"
                >
                    <User color="#ffffff" size={16} />
                </button>
                {/* Notification Bell Icon Button */}
                <button
                    onClick={() => handlenav("/agent/notification")}
                    className="w-8 h-8 sm:w-7 sm:h-7 bg-blue-500 rounded-full flex justify-center items-center relative hover:bg-blue-600 transition-colors"
                >
                    <Bell color="#ffffff" size={16} />
                    {/* Notification Badge with unread count */}
                    {unreadCount > 0 && (
                        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-red-500 text-white text-[11px] font-bold rounded-full flex items-center justify-center border-2 border-white px-1 leading-none z-10">
                            {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                    )}
                </button>

                {(userType === "customer" || userType === "agent") && (
                    <button
                        onClick={handleLogout}
                        className="h-8 px-4 sm:w-20 bg-blue-500 rounded-full flex justify-center items-center transform active:scale-95 transition-all duration-150 hover:bg-blue-600 text-white text-center text-sm font-medium whitespace-nowrap"
                        style={{ minWidth: "64px" }}
                    >
                        Logout
                    </button>
                )}
            </div>
        </div>
    );
};

export default Navbar;